import { ConfirmDialog } from "components/ConfirmDialog";
import { useTranslation } from "react-i18next";
type Props = {
	maxDurationSeconds: number;
	visible: boolean;
	onDismiss: () => void;
};

export const RecordingLimitAlert = ({
	maxDurationSeconds,
	visible,
	onDismiss,
}: Props) => {
	const { t } = useTranslation();
	return (
		<ConfirmDialog
			title={t("recorder.alert.title")}
			body={t("recorder.alert.body", {
				maxDuration: maxDurationSeconds,
			})}
			visible={visible}
			dismissCallback={onDismiss}
			confirmCallback={onDismiss}
			confirmCta={t("common.ok")}
		/>
	);
};
